<script lang="ts" setup>
  import { computed } from 'vue'
  import { type CheckboxValue } from './BaseCheckbox.types'
  import { TEST_ID } from './BaseCheckbox.constants'

  interface Props {
    modelValue: CheckboxValue
    id: string
    name: string
    dataTest?: string
  }
  interface Emits {
    (e: 'update:modelValue', value: CheckboxValue): void
  }

  const props = withDefaults(defineProps<Props>(), {
    modelValue: false,
    dataTest: TEST_ID,
  })
  const emit = defineEmits<Emits>()

  const value = computed({
    get: () => props.modelValue,
    set: (value) => {
      emit('update:modelValue', value)
    },
  })
</script>

<template>
  <div :data-test="dataTest" class="checkbox">
    <input
      v-bind="$attrs"
      :id="id"
      v-model="value"
      :value="id"
      :name="name"
      type="checkbox"
      :data-test="`${dataTest}-input`"
    />
    <label :for="id" :data-test="`${dataTest}-label`">
      <slot />
    </label>
  </div>
</template>

<style lang="scss" scoped>
  @import './BaseCheckbox';
</style>
